import { Component, EventEmitter, Input, Output } from '@angular/core';

export type CtaGenericType = 'primary' | 'secondary';

@Component({
  selector: 'app-cta-generic',
  templateUrl: './cta-generic.component.html',
  styleUrls: ['./cta-generic.component.scss'],
  standalone: false,
})
export class CtaGenericComponent {
  /** Translation key for the button label (translated inside the component). */
  @Input() labelKey = '';
  /** Optional Material ligature icon name (e.g. `edit_calendar`). Hidden on mobile. */
  @Input() iconName?: string;
  /** Optional registered SVG icon name (e.g. `printer`). Hidden on mobile. Takes precedence over `iconName`. */
  @Input() svgIcon?: string;
  /** Visual style of the button. */
  @Input() type: CtaGenericType = 'primary';
  @Input() disabled = false;
  @Input() loading = false;

  @Output() clicked = new EventEmitter<void>();

  public onClick(): void {
    if (this.disabled || this.loading) {
      return;
    }
    this.clicked.emit();
  }
}
